<div class="confirmation">
    <h2 mat-dialog-title><mat-icon color="warn" class="d-table">warning</mat-icon>{{ dialogData.title }}</h2>
    <p>{{ dialogData.displayText }}</p>
    <div class="btn-group justify-content-end" role="group">
        @if (!dialogData.hideCancelBtn) {
        <button mat-button mat-dialog-close>{{ dialogData.cancelBtnName ?? 'No' }}</button>
        }
        <button mat-button [mat-dialog-close]="true">{{ dialogData.confirmBtnName ?? 'Yes' }}</button>
    </div>
</div>